export default "__VITE_ASSET__Bwe_M5LO__"